const SnowTypes = {
    NATURAL: 'NATURAL',
    MIXED: 'MIXED',
    ARTIFICIAL: 'ARTIFICIAL'
}

export default SnowTypes;
